import { Component } from '@angular/core';
import { UploadComponent } from '../../components/upload/upload.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-job',
    imports: [UploadComponent],
    templateUrl: './create-job.component.html',
    styleUrl: './create-job.component.scss'
})

export class CreateJobComponent {

  constructor(
    private router: Router
  ) { }

  uplaodCompleted(jobId: number | null) {
    if (jobId !== null) {
      setTimeout(() => {
        this.router.navigate(['dashboard/job/' + jobId]);
      }, 100)
    }
  }
}
